import {CookieHelper} from "../modules/CookieHelper";

class PriceVatToggleHandler
{
    constructor() {
        this.initListeners();
    }

    initListeners() {
        const pp_switch_radio_buttons = document.querySelectorAll('input[type=radio].pp-switch');

        if (0 === pp_switch_radio_buttons.length) {
            return;
        }

        Array.from(pp_switch_radio_buttons).forEach(pp_switch_radio_button => {
            pp_switch_radio_button.addEventListener('change', (evt) => {
                const value = evt.target.value;

                CookieHelper.setCookie('price_incl_vat', value, 365)

                location.reload();
            });
        });
    }
}

new PriceVatToggleHandler();
